<template lang="html">

  <VqModal
    :name="modalName"
    class="vq-modal-delete-vm">
    <template v-slot:header>
      <h2 class="modal-title">{{setTitleContext($t('components.modalDeleteRole.del'))}} <span class="is-bold">{{ $t('components.modalDeleteRole.role') }}</span></h2>
      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
  <div class="forms">
    <form>
      <div class="container has-separator">
        <div class="row">
          <div>
            <p class="pb-5">
              {{ $t('components.modalDeleteRole.title') }} "<span class="is-bold">{{role.name}}</span>"
            </p>
            <p class="is-thin">{{ $t('components.modalDeleteRole.content') }}</p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
    <template v-slot:footer>
  <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalDeleteRole.cancel') }}</button>
  <button
    v-if="$store.state.display_edit"
    :class="{'is-loading': isFormLoading}"
    type="button"
    class="button is-small is-danger is-outline"
    @click="submit">{{ $t('components.modalDeleteRole.delete') }}
  </button>
</template>
  </VqModal>

</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

import ROLE from '@/api/roles';

import VqModal from '@/components/VqModal.vue';


export default {
  name: 'ModalDeleteRole',
  mixins: [eventHubMixin],
  components: {
    VqModal,
  },

  data() {
    return {
      modalName: 'delete-role',
      context: 'delete',
      errors: [],
      role: {
        name: ""
      },
      isFormLoading: false,
    };
  },
  mounted() {
    this.onOpenModal(this.modalName, (data) => {
      this.role = data
    })
  },
  methods: {
    emitSuccessToaster() {
      this.emitAddToaster({
        title: this.$t('components.modalDeleteRole.toasts.success.title'),
        text: this.$t('components.modalDeleteRole.toasts.success.content'),
        state: 'success',
      });
    },

    emitFailedToaster(description) {
      this.emitAddToaster({
        title: this.$t('components.modalDeleteRole.toasts.failed.title'),
        text: `${this.$t('components.modalDeleteRole.toasts.failed.content')} ${description}`,
        state: 'danger',
      });
    },

    submit() {
      this.isFormLoading = true;
      ROLE.delete(this.role.id).then(
        (res) => {
          this.isFormLoading = false
          this.emitSuccessToaster()
          this.$emit('deleterole', this.role.id)
          this.close()
        },
        (err) => {
          this.emitFailedToaster(err.response.data.non_field_errors)
          this.close()

        },
      );
    },
    close() {
      this.emitCloseModal(this.modalName)
    },
    setTitleContext(title) {
      return title.charAt(0).toUpperCase() + title.slice(1)
    },
  },
  computed: {

  },
};
</script>

<style scoped lang="scss">
</style>
